import { Component, HostBinding, Input } from '@angular/core';
import {
  LucideArrowUp,
  LucideBadgeCheck,
  LucideBell,
  LucideBriefcaseBusiness,
  LucideBuilding2,
  LucideCalendarDays,
  LucideCalendarPlus,
  LucideClock,
  LucideChevronDown,
  LucideChevronLeft,
  LucideChevronRight,
  LucideChevronUp,
  LucideCircle,
  LucideCircleAlert,
  LucideCircleCheck,
  LucideCircleChevronLeft,
  LucideCircleChevronRight,
  LucideCircleChevronUp,
  LucideDownload,
  LucideDynamicIcon,
  LucideEllipsisVertical,
  LucideEye,
  LucideEyeOff,
  LucideFilter,
  LucideGripVertical,
  LucideGlobe,
  LucideListChecks,
  LucideListX,
  LucideLogIn,
  LucideLogOut,
  LucideMapPin,
  LucideMegaphone,
  LucideMegaphoneOff,
  LucideMenu,
  LucideMessageCircle,
  LucideMessageSquareOff,
  LucideMessageSquareText,
  LucideNotebookPen,
  LucidePaperclip,
  LucidePencil,
  LucidePlay,
  LucidePlus,
  LucideSearch,
  LucideSend,
  LucideSettings,
  LucideShare2,
  LucideShield,
  LucideShieldCheck,
  LucideShieldX,
  LucideTrash2,
  LucideTriangleAlert,
  LucideUpload,
  LucideUserMinus,
  LucideUserPlus,
  LucideUserRound,
  LucideUserRoundCheck,
  LucideUserRoundX,
  LucideX,
  type LucideIconInput,
} from '@lucide/angular';

const CITIZEX_ICONS: Readonly<Record<string, LucideIconInput>> = {
  'arrow-up': LucideArrowUp,
  'badge-check': LucideBadgeCheck,
  bell: LucideBell,
  'briefcase-business': LucideBriefcaseBusiness,
  'building-2': LucideBuilding2,
  'calendar-days': LucideCalendarDays,
  'calendar-plus': LucideCalendarPlus,
  clock: LucideClock,
  'chevron-down': LucideChevronDown,
  'chevron-left': LucideChevronLeft,
  'chevron-right': LucideChevronRight,
  'chevron-up': LucideChevronUp,
  circle: LucideCircle,
  'circle-alert': LucideCircleAlert,
  'circle-check': LucideCircleCheck,
  'circle-chevron-left': LucideCircleChevronLeft,
  'circle-chevron-right': LucideCircleChevronRight,
  'circle-chevron-up': LucideCircleChevronUp,
  download: LucideDownload,
  'ellipsis-vertical': LucideEllipsisVertical,
  eye: LucideEye,
  'eye-off': LucideEyeOff,
  filter: LucideFilter,
  'grip-vertical': LucideGripVertical,
  globe: LucideGlobe,
  'list-checks': LucideListChecks,
  'list-x': LucideListX,
  'log-in': LucideLogIn,
  'log-out': LucideLogOut,
  'map-pin': LucideMapPin,
  megaphone: LucideMegaphone,
  'megaphone-off': LucideMegaphoneOff,
  menu: LucideMenu,
  'message-circle': LucideMessageCircle,
  'message-square-off': LucideMessageSquareOff,
  'message-square-text': LucideMessageSquareText,
  'notebook-pen': LucideNotebookPen,
  paperclip: LucidePaperclip,
  pencil: LucidePencil,
  play: LucidePlay,
  plus: LucidePlus,
  search: LucideSearch,
  send: LucideSend,
  settings: LucideSettings,
  'share-2': LucideShare2,
  shield: LucideShield,
  'shield-check': LucideShieldCheck,
  'shield-x': LucideShieldX,
  'trash-2': LucideTrash2,
  'triangle-alert': LucideTriangleAlert,
  upload: LucideUpload,
  'user-minus': LucideUserMinus,
  'user-plus': LucideUserPlus,
  'user-round': LucideUserRound,
  'user-round-check': LucideUserRoundCheck,
  'user-round-x': LucideUserRoundX,
  x: LucideX,
};

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [LucideDynamicIcon],
  template: '<svg [lucideIcon]="icon"></svg>',
  styles: [
    `
      :host {
        align-items: center;
        display: inline-flex;
        flex: 0 0 auto;
        height: 1em;
        justify-content: center;
        line-height: 1;
        vertical-align: middle;
        width: 1em;
      }

      svg {
        display: block;
        height: 100%;
        stroke: currentColor;
        width: 100%;
      }
    `,
  ],
})
export class CxIconComponent {
  @Input({ required: true }) name = '';

  get icon(): LucideIconInput {
    return CITIZEX_ICONS[this.name] ?? LucideCircleAlert;
  }

  @HostBinding('attr.data-icon')
  get dataIcon(): string {
    return this.name;
  }
}
